<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				合同详情
			</el-col>
			<el-col :xs="24" :md="18" style="text-align: right;">
				<el-button v-if="$hasPermission('plat:platcontract:checked')" v-show="dataForm.status===1"
					type="primary" @click="dataFormSubmitHandle('1',dataForm.id)">通过审核
				</el-button>
				<!-- <el-button v-show="dataForm.status==='2'" type="primary"
				           @click="dataFormSubmitHandle('1',dataForm.id)">通过审核
				</el-button> -->
				<el-button v-if="$hasPermission('plat:platcontract:checked')" v-show="dataForm.status===1"
					type="primary" style="background-color: thistle" @click="dataFormSubmitHandle('0',dataForm.id)">驳回
				</el-button>
				<el-button @click="init()">刷新</el-button>
				<el-button @click="handleNext()">返回</el-button>
			</el-col>
		</el-row>
		<div style="padding: 50px;">
			<el-form :model="dataForm" :rules="dataRule" ref="dataForm"
				:label-width="$i18n.locale === 'en-US' ? '160px' : '160px'">
				<el-row>
					<el-col :md="12" :lg="12">
						<el-form-item label="甲方主体" prop="firstId">
							<el-select style="width: 95%;" v-model="dataForm.firstId" placeholder="甲方主体"
								:disabled="true" clearable>
								<el-option v-for="platBody in firstBody" :key="platBody.id" :label="platBody.caName"
									:value="platBody.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
          <el-col :md="12" :lg="12">
						<el-form-item label="乙方主体" prop="abbreviation">
							<el-input v-model="dataForm.abbreviation" placeholder="乙方主体"  :disabled="true" ></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="12">
						<el-form-item label="甲方联系人" prop="firstUser">
							<el-input style="width: 95%;" v-model="dataForm.firstUser" :disabled="true"
								placeholder="甲方联系人" maxlength="10" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="12">
						<el-form-item label="乙方联系人" prop="secondUser">
							<el-input style="width: 95%;" v-model="dataForm.secondUser" :disabled="true"
								placeholder="乙方联系人" maxlength="10" show-word-limit></el-input>
						</el-form-item>
					</el-col>
          <el-col :md="12" :lg="12">
						<el-form-item label="甲方联系电话" prop="firstPhone">
							<el-input style="width: 95%;" :disabled="true" v-model="dataForm.firstPhone"
								placeholder="甲方联系电话" maxlength="11"></el-input>
						</el-form-item>

					</el-col>
					<el-col :md="12" :lg="12">
						<el-form-item label="乙方联系电话"  prop="secondPhone">
							<el-input style="width: 95%;" :disabled="true" v-model="dataForm.secondPhone"
								placeholder="乙方联系电话" maxlength="11"></el-input>
						</el-form-item>

					</el-col>
					<el-col :md="24" :lg="12">
						<el-form-item label="执行开始日期" prop="startDate">
							<el-date-picker style="width: 95%;" v-model="dataForm.startDate" :disabled="true"
								start-placeholder="开始日期" align="right" type="date" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					
					<el-col :md="24" :lg="12">
						<el-form-item label="执行结束日期" prop="endDate">
							<el-date-picker style="width: 95%;" v-model="dataForm.endDate" :disabled="true"
								end-placeholder="结束日期" align="right" type="date" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="12">
						<el-form-item label="平台服务费" prop="payFee">
							<el-input style="width: 95%;" v-model="dataForm.payFee" :disabled="true" placeholder="平台服务费"
								maxlength="10" show-word-limit><i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i></el-input>
						</el-form-item>
					</el-col>
          			<!-- <el-col :md="12" :lg="12">
						<el-form-item label="服务费承担方" prop="serviceFeeType">
							<el-radio-group v-model="dataForm.serviceFeeType" :disabled="true">
								<el-radio :label="0">企业承担服务费</el-radio>
								<el-radio :label="1">个人承担服务费</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col> -->
				</el-row>
				<el-form-item label="附件">
					<!-- <el-upload class="upload-demo contract" :action="url" multiple :limit="20" :on-remoe="handle  Remove" :before-remove="beforeRemove"
						:on-preview="handlePreview" :file-list="fileList">
					</el-upload> -->
					<el-upload class="upload-demo" :before-remove="beforeRemove" :action="url" :on-remove="handleRemove" multiple :limit="20"
						:on-preview="handlePreview" :before-upload="beforeUploadHandle" :on-error="backerror"
						:on-success="successHandle" :file-list="fileList">
						<el-button size="small" type="primary" v-if="fileList.length == 0">上传附件</el-button>
						<div slot="tip" class="el-upload__tip" v-if="fileList.length == 0">支持上传PDF、图片等</div>
					</el-upload>
				</el-form-item>







				<!-- <el-row>
					<el-col :md="12" :lg="8">
						<el-form-item label="合同类别" prop="contractType">
							<ren-select style="width: 95%;" :isDisabled="true" v-model="dataForm.contractType"
								dict-type="contractType"></ren-select>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方主体" prop="firstId">
							<el-select style="width: 95%;" v-model="dataForm.firstId" placeholder="甲方主体"
								:disabled="true" clearable>
								<el-option v-for="platBody in firstBody" :key="platBody.id" :label="platBody.caName"
									:value="platBody.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方主体" prop="secondId">
							<el-select style="width: 95%;" v-model="dataForm.secondId" placeholder="乙方主体"
								:disabled="true" clearable>
								<el-option v-for="platBody in secondBody" :key="platBody.id" :label="platBody.bodyName"
									:value="platBody.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="合同金额" prop="money">
							<el-input style="width: 95%;" v-model="dataForm.money" :disabled="true" type="number"
								placeholder="合同金额"></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方开户行" prop="firstBankName">
							<el-input style="width: 95%;" v-model="dataForm.firstBankName" placeholder="甲方开户行"
								:disabled="true" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方开户行" prop="secondBankName">
							<el-input style="width: 95%;" v-model="dataForm.secondBankName" placeholder="乙方开户行"
								:disabled="true" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="任务属性" prop="settleType">
							<ren-select :isDisabled="true" style="width: 95%;" v-model="dataForm.settleType"
								dict-type="settleType"></ren-select>
						</el-form-item>

					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方账户" prop="firstBankAccount">
							<el-input style="width: 95%;" v-model="dataForm.firstBankAccount" placeholder="甲方账户"
								maxlength="50" :disabled="true" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方账户" prop="secondBankAccount">
							<el-input style="width: 95%;" v-model="dataForm.secondBankAccount" placeholder="乙方账户"
								maxlength="50" :disabled="true" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="发票类型" prop="ticketType">
							<ren-select style="width: 95%;" :isDisabled="true" v-model="dataForm.ticketType"
								dict-type="ticketType"></ren-select>
						</el-form-item>

					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方地址" prop="firstAddress">
							<el-input style="width: 95%;" v-model="dataForm.firstAddress" placeholder="甲方地址"
								maxlength="100" :disabled="true" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方地址" prop="secondAddress">
							<el-input style="width: 95%;" v-model="dataForm.secondAddress" placeholder="乙方地址"
								maxlength="100" :disabled="true" show-word-limit></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :md="12" :lg="8">
						<el-form-item label="平台服务费" prop="payFee">
							<el-input style="width: 95%;" v-model="dataForm.payFee" :disabled="true" placeholder="平台服务费"
								maxlength="10" show-word-limit><i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方联系人" prop="firstUser">
							<el-input style="width: 95%;" v-model="dataForm.firstUser" :disabled="true"
								placeholder="甲方联系人" maxlength="10" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方联系人" prop="secondUser">
							<el-input style="width: 95%;" v-model="dataForm.secondUser" :disabled="true"
								placeholder="乙方联系人" maxlength="10" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="24" :lg="8">
						<el-form-item label="执行开始日期" prop="startDate">
							<el-date-picker style="width: 95%;" v-model="dataForm.startDate" :disabled="true"
								start-placeholder="开始日期" align="right" type="date" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方联系电话" prop="firstPhone">
							<el-input style="width: 95%;" :disabled="true" v-model="dataForm.firstPhone"
								placeholder="甲方联系电话" maxlength="11"></el-input>
						</el-form-item>

					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方联系电话"  prop="secondPhone">
							<el-input style="width: 95%;" :disabled="true" v-model="dataForm.secondPhone"
								placeholder="乙方联系电话" maxlength="11"></el-input>
						</el-form-item>

					</el-col>
					<el-col :md="24" :lg="8">
						<el-form-item label="执行结束日期" prop="endDate">
							<el-date-picker style="width: 95%;" v-model="dataForm.endDate" :disabled="true"
								end-placeholder="结束日期" align="right" type="date" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label-width="160px"  label="甲方社会信用代码" prop="firstTaxCode">
							<el-input style="width: 95%;" :disabled="true" v-model="dataForm.firstTaxCode"
								placeholder="甲方社会信用代码" maxlength="11"></el-input>
						</el-form-item>

					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label-width="160px"  label="乙方社会信用代码" prop="secondTaxCode">
							<el-input style="width: 95%;" :disabled="true" v-model="dataForm.secondTaxCode"
								placeholder="乙方社会信用代码" maxlength="11"></el-input>
						</el-form-item>

					</el-col>
					<el-col :md="12" :lg="12">
						<el-form-item label="结算方式" prop="serviceFeeType">
							<el-radio-group :disabled="true" v-model="dataForm.serviceFeeType">
								<el-radio :label="0">企业承担服务费</el-radio>
								<el-radio :label="1">个人承担服务费</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>

				</el-row>

				<el-form-item label="合同说明" prop="remark">
					<el-input type="textarea" style="width: 95%;" rows="4" v-model="dataForm.remark" placeholder="合同说明"
						:disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="附件">
					<el-upload class="upload-demo contract" :action="url" multiple :limit="20" :disabled="true"
						:on-preview="handlePreview" :file-list="fileList">
					</el-upload>
				</el-form-item> -->
				<!-- 审核相关 start -->
				<el-row style="border-top: 5px solid #F3F4F4;" v-if="dataForm.platContractProcessDTOList.length > 0">
					<div style="font-size: 14px;font-weight: bold;color: #333333;line-height: 40px;">合同状态</div>
					<div style="line-height: 25px;padding: 10px 0;font-size: 12px;">
						<p style="margin: 0;">
							合同编号<span style="margin-left: 40px;">{{dataForm.contractCode}}</span>
						</p>
					</div>
					<p style="margin: 0;line-height: 50px;border-bottom:1px solid #F3F4F4;"
						v-for="(value,key) in dataForm.platContractProcessDTOList">
						<!-- <span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span> -->
						{{value.createDate}}
						<span style="margin-left: 40px;">{{value.createName}}</span>
						<span style="margin-left: 40px;">{{value.operation}}</span>
						<span style="margin-left: 40px;">{{value.content}}</span>
					</p>
				</el-row>

				<!-- 审核相关 end -->
			</el-form>
		</div>
		<!-- 图片预览 -->
		<el-dialog :visible="imgVisable" :before-close="handleClose">
			<el-image :src="imgUrl"></el-image>
		</el-dialog>
	</el-card>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
import { addDynamicRoute } from '@/router'


export default {
  data () {
    return {
		role: Cookies.get("admin_role"),
	  url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      num: 0,
      fileList: [],
      visible: false,
	  imgUrl:'',
	  imgVisable:false,
      firstBody: [],
      secondBody: [],
      dataForm: {
        id: '',
        contractCode: '',
        contractType: '',
        money: '',
		abbreviation:'',
        settleType: '',
        ticketType: '',
        startDate: '',
        endDate: '',
        remark: '',
        firstId: '',
        firstBody: '',
        firstBankName: '',
        firstBankAccount: '',
        firstUser: '',
        peyFee: '',
        firstPhone: '',
        firstAddress: '',
        firstTaxCode: '',
        secondBody: '',
        secondId: '',
        secondBankName: '',
        secondBankAccount: '',
        secondUser: '',
        secondPhone: '',
        secondAddress: '',
        inStatus: '',
        secondTaxCode: '',
        platContractFileDTOList: [],
        platContractProcessDTOList: [],
        serviceFeeType:'',
      },
      fileList: [],
      url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      num: 0
    }
  },
  computed: {
    dataRule () {
      return {
        content: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }]
      }
    }
  },
  created () {
	this.url = `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`
    this.dataForm.id = this.$route.params.id || ''
    this.$http.get(`/sys/plat/info/ca/list`)
      .then(({
        data: res
      }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.firstBody = res.data
      }).catch(() => {})
    this.$http.get(`/sys/plat/body/list`)
      .then(({
        data: res
      }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.secondBody = res.data
      }).catch(() => {})
    this.init()
  },
  methods: {
	  //   返回上级
	handleNext(){
		console.log(this.$route.params.parentId)
		if(this.$route.params.parentId){//企业开票记录详情返回
			const routeParams = {
				routeName: 'plat-platticketrecordqy__任务详情',
				title: `申请开票`,
				path: 'plat/platinvoicingtasklist-add',
				params: {
					id:this.$route.params.parentId,
					isThreeRoute:true
				}
			}
			addDynamicRoute(routeParams, this.$router)
		}else{
			this.$router.back(this.num)
		}
	},
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/contract/${this.dataForm.id}`).then(({
        data: res
      }) => {
        if (res.code !== 0) {
          return this.$message({
            message: res.msg,
            type: 'error',
            duration: 500,
            onClose: () => {
              this.$router.back(-1)
            }
          })
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.fileList = []
        if (res.data.platContractFileDTOList.length > 0) {
          let filelist = res.data.platContractFileDTOList
          for (let i = 0; i < filelist.length; i++) {
            let info = []
            info.status = 'success'
            filelist[i].url = filelist[i].filePath
            info.name = filelist[i].fileName + '.' + filelist[i].fileType
            info.response = []
            info.response.code = 0
            info.response.msg = 'success'
            info.response.data = filelist[i]
            console.log(info)
            this.fileList.push(info)
          }
        }
      }).catch(() => {})
    },
	beforeRemove(file, fileList) {
		if(this.role != "OPERATE"){
			this.$message.error('非运营人员无法操作！')
			return false;
		}
		if(file.status == 'success')
		return this.$confirm(`确定移除 ${ file.name }？`);
	},
	handleRemove (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.fileList = fileList
      this.dataForm.platContractFileDTOList = fileList
    },
    // 上传成功
    async successHandle (res, file, fileList) {
      console.log(fileList)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }

      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.fileList = fileList
      this.dataForm.platContractFileDTOList = fileList
      this.num--
	  console.log(fileList)
	  const res1 = await this.$http.post('/sys/plat/contract/saveAttachment',{
		id:this.dataForm.id,
		platContractFileDTOList:[{
			"fileName":fileList[0].name,
			"fileType":fileList[0].response.data.fileType,
			"contractId":fileList[0].size,
			"filePath":fileList[0].response.data.url
		}]
	  })
    },
	beforeUploadHandle (file) {
      console.log(file)
      if (file.type != 'application/pdf' && file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file
        .type !== 'image/png' && file.type !== 'image/gif' && file.type !== 'application/vnd.ms-excel' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error(this.$t('upload.tip', {
          'format': 'jpg、png、gif,pdf,xls,xlsx'
        }))
        return false
      }
      if (file.size / 1024 / 1024 > 30) {
        this.$message.error('文件太大，只能上传30MB以内的文件')
        return false
      }
      this.num++
    },
    handlePreview (file) {
      if (!file.response.data.url) {
        this.$message.error('下载失败')
        return
      }
      const type = file.response.data.url.split('.')[4]
      // 判断文件类型
      if (type === 'doc' || type === 'docx' || type === 'xlsx' || type === 'xls' || type === 'ppt' || type ===
					'pptx') {
        // 在当前浏览器直接下载
        document.location.href = file.response.data.url
      } else {
        // 图片在浏览器打开 新的页面展示
        window.open(file.response.data.url, file.name)
      }
    },
	backerror (e) {
      this.$message.error('文件上传失败，请重试')
    },
	handleClose(){
		this.imgVisable = false;
		this.imgUrl = ''
	},
    // 表单提交
    dataFormSubmitHandle: debounce(function (inStatus, id) {
      let _this = this
      this.$prompt('请输入审核理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        this.$http.post('/sys/plat/contract/audit?inStatus=' + inStatus + '&content=' + value +
						'&id=' + id, {
          headers: {
            'content-type': 'application/json;charset=utf-8'
          }
        }).then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.$router.back(-1)
            }
          })
        }).catch(() => {})
      })
    })
  }
}
</script>
<style>
	.contract .el-upload {
		display: none;
	}
</style>
